export const urls = {
  upworkURL: "https://www.upwork.com/freelancers/~0126c518b8543236eb",
  fbURL: "https://www.facebook.com/AbdRaouf.zk/",
  twitterURL: "https://twitter.com/abdraoufx",
  githubURL: "https://github.com/abdraoufx",
  frontEndMentorURL: "https://www.frontendmentor.io/profile/abdraoufx",
};
